/**
 * The scale the main menu's real-time buttons launch at. Human (k 1/20) is the game's world now
 * (decisions 49, 87): people a twentieth of the classic unit, biome stands dressing the ground.
 * Classic is the old prototype scale, kept for comparison. A persisted per-browser setting, like
 * developer mode; URL launches (`?action&scale=…`) keep their own parameter and ignore it.
 */

import type { ScaleProfileName } from '../types';

const STORAGE_KEY = 'orbituary-action-scale';

function load(): ScaleProfileName {
  try { return localStorage.getItem(STORAGE_KEY) === 'classic' ? 'classic' : 'human'; } catch { return 'human'; }
}

let current: ScaleProfileName = load();

export function actionScale(): ScaleProfileName { return current; }

export function setActionScale(v: ScaleProfileName): void {
  current = v;
  try { localStorage.setItem(STORAGE_KEY, v); } catch { /* storage unavailable */ }
  updateActionScaleToggles();
}

/** Every `.setting-action-scale` button shows the scale it will launch. */
export function updateActionScaleToggles(): void {
  for (const el of Array.from(document.querySelectorAll<HTMLElement>('.setting-action-scale'))) {
    el.textContent = current === 'human' ? 'HUMAN 1/20' : 'CLASSIC';
    el.classList.toggle('off', current !== 'human');
  }
}
